var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"width":"100%","min-height":"500px"},attrs:{"elevation":"3"}},[_vm._v(" // Bientot disponible ")])
}
var staticRenderFns = []

export { render, staticRenderFns }